import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { User } from '../../auth/model/user.model';
import { Subscription } from 'rxjs';
import { ApiMessage, ApiMessageService, MessageType } from '../api-message.service';
import { NotificationsService } from 'angular2-notifications';
import { ServiceReg } from '../../auth/auth.module';
import { MenuService } from './menu.service';
import { NavbarMenu } from './model/navbar-menu.model';
import { environment } from '../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { UtenteService } from '../../+configurazione/utente/utente.service';

@Component({
    selector: 'app-header1',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {


  public onUserActivated: Subscription = new Subscription();
  public onLoad: Subscription = new Subscription();
  public onNavbarEvaluated: Subscription = new Subscription();
  public navbarMenu: NavbarMenu = null;

  public user: User = null;
  public spinner = false;
  public authenticated = false;

  public services = ServiceReg;

  public oidcEnable = false;

  public aceUser = false;
  
  public notificationOptions = {
    timeOut: 5000,
    pauseOnHover: true,
    clickToClose: true,
    showProgressBar: false,
    position: ['top', 'right']
  }

  constructor(private menuService: MenuService,
              private utenteService: UtenteService,
              private authService: AuthService,
              private oidcSecurityService: OidcSecurityService,
              private apiMessageService: ApiMessageService,
              private notificationService: NotificationsService) {
  }

  public ngOnInit() {
    this.oidcEnable = (environment.oidc.enable === 'true') ? true : false;

    if(this.oidcEnable) {
      this.oidcSecurityService.checkAuth().subscribe(({isAuthenticated, userData}) => {
        this.authenticated = isAuthenticated;
        if (isAuthenticated) {
          this.authService.getUser().subscribe((user: User) => {
            this.authService.userActivated.next(user);
            this.user = user;
            this.utenteService.byUsername(user.username).subscribe((result) => {
              this.aceUser = true;
            });      
          });
        }      
      });  
    } else {
      this.authService.getUser().subscribe((user: User) => {
        this.authService.userActivated.next(user);
        this.user = user;
      });
    }
    this.onUserActivated = this.authService.userActivated.subscribe((user: User) => {
      if (user != null) {
        this.authenticated = true;
        this.user = user;
        this.menuService.evaluateNavbar();
      } else {
        this.user = null;
      }
    });
    if (this.user && !this.navbarMenu) {
      this.menuService.evaluateNavbar();
    }
    this.onNavbarEvaluated = this.menuService.navbarEvaluated.subscribe( (navbarMenu) => {
      this.navbarMenu = navbarMenu;
    });

    this.apiMessageService.onApiMessage.subscribe(
      (message: ApiMessage) => {
        this.showNotification(message.type, message.message);
      }
    );
    this.apiMessageService.onLoad.subscribe((value) => {
      this.spinner = value;
    });

  }

  public onLogout() {
    this.authService.logout();
    this.notificationService.success('Success', 'Logout effettuato');
    this.menuService.destroyNavbar();
    this.authenticated = false;
  }

  public isAuthenticated() {
      return this.authenticated;
  }

  public ngOnDestroy() {
      this.onUserActivated.unsubscribe();
      this.onLoad.unsubscribe();
      this.onNavbarEvaluated.unsubscribe();
  }

  private showNotification(messageType: MessageType, message: string) {
    if (messageType === MessageType.SUCCESS) {
      this.notificationService.success('Ok', message, this.notificationOptions);
    } else if (messageType === MessageType.ERROR) {
      this.notificationService.error('Errore', message, this.notificationOptions);
    } else if (messageType === MessageType.WARNING) {
      this.notificationService.alert('Alert', message, this.notificationOptions);
    }
  }

  OnClickHelp() {
    window.open("https://consiglionazionaledellericerche.github.io/ace-docs/");
  }
}
